import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 13,
	viewBox: "0 0 16 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.3457 2.81641L9.79297 5.73633C10.0215 6.19336 10.6309 6.32031 11.0117 6.01562L13.2969 4.1875C13.1699 4.03516 13.0938 3.80664 13.0938 3.57812C13.0938 3.01953 13.5254 2.5625 14.1094 2.5625C14.668 2.5625 15.125 3.01953 15.125 3.57812C15.125 4.16211 14.668 4.59375 14.1094 4.59375C14.084 4.59375 14.084 4.59375 14.084 4.59375L12.916 10.9922C12.7891 11.7539 12.1035 12.3125 11.3164 12.3125H4.2832C3.49609 12.3125 2.81055 11.7539 2.68359 10.9922L1.51562 4.59375C0.931641 4.59375 0.5 4.16211 0.5 3.57812C0.5 3.01953 0.931641 2.5625 1.51562 2.5625C2.07422 2.5625 2.53125 3.01953 2.53125 3.57812C2.53125 3.80664 2.45508 4.03516 2.32812 4.1875L4.58789 6.01562C4.99414 6.32031 5.57812 6.19336 5.80664 5.73633L7.2793 2.81641C6.97461 2.63867 6.79688 2.33398 6.79688 1.95312C6.79688 1.39453 7.22852 0.9375 7.8125 0.9375C8.37109 0.9375 8.82812 1.39453 8.82812 1.95312C8.82812 2.33398 8.625 2.63867 8.3457 2.81641Z",
		fill: "url(#paint0_linear_3395_38311)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_3395_38311",
		x1: .5,
		y1: 7,
		x2: 15.5,
		y2: 7,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF9790" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#FFB13B"
		})]
	}) })]
});
export { SvgCrown as ReactComponent };
